import React, { useState } from 'react';
import axios from 'axios';
import Header from '../components/Cattle-feed/Header';
import Footer from '../components/Cattle-feed/Footer';

const contacts = [
  {
    country: 'INDIA',
    address:
      '617, 6th Floor, Saffron Business Park, Nr. Jashoda Nagar Cross Road, Jashoda Nagar, Maninagar East, Ahmedabad - 382445',
    email: [
      'info@edgeinfinium.com',
      'edgeinfinium@gmail.com',
      'info@thecattlefeed.com',
    ],
    phone: '+91 9662538245',
    mapSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.0993158281226!2d72.62137307628859!3d22.983375117788068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8557cc44fcaf%3A0xfc4fc893aa5959a6!2sEDGE%20INFINIUM%20PVT%20LTD.!5e0!3m2!1sen!2sin!4v1718446404970!5m2!1sen!2sin',
  },
  {
    country: 'ITALY',
    address:
      'Mediterraneo Feed & Food Trading SRL In Collaboration With Edge Infinium Via dei Tornabuoni 41 50123 Florence(FI) Tuscany, Italy',
    email: ['info@mediterraneofft.com'],
    phone: '+39 055 762 4185',
    mobileNo: '+39 349 824 6712',
    website: 'www.mediterraneotradingsrl.com',
    mapSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7735.493594846793!2d11.250310511329621!3d43.770472090893776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a56aa615a2e51%3A0x6eb04397f0a7a616!2sVia%20de%20Tornabuoni%2C%2041%2C%2050123%20Firenze%20FI%2C%20Italy!5e1!3m2!1sen!2sin!4v1779171100452!5m2!1sen!2sin',
  },
  {
    country: 'USA',
    address: 'Anju Singh (Director) 453 Farnham Ave Lodi, NJ 07644 USA',
    email: ['singh@thecattlefeed.com'],
    phone: '+001 -201 772 0292',
    mapSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3016.5153303580596!2d-74.09180239999999!3d40.88250939999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f9645f39d5c5%3A0x622060fd16ec7f5a!2s453%20Farnham%20Ave%2C%20Lodi%2C%20NJ%2007644%2C%20USA!5e0!3m2!1sen!2sin!4v1718613506359!5m2!1sen!2sin',
  },
];

const getWebsiteUrl = website =>
  website?.match(/^https?:\/\//i) ? website : `https://${website}`;

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const response = await axios.post('/api/contact', formData);

      if (response.data.success) {
        setStatusMessage('Message sent successfully');
      } else {
        setStatusMessage('Failed to send message');
      }
    } catch (error) {
      setStatusMessage('An error occurred while sending the message');
    }

    setFormData({
      name: '',
      email: '',
      message: '',
    });
  };

  return (
    <div id="wrapperParallax" className="wrapper wrapper-boxed clearfix">
      <Header />

      <h1
        style={{
          color: '#7B0323',
          textAlign: 'center',
          fontSize: 'clamp(32px,5vw,50px)',
          marginTop: '30px',
        }}
      >
        Contact Us
      </h1>

      {/* Contact Form */}
      <div
        style={{
          maxWidth: '1000px',
          margin: '0 auto',
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
        }}
      >
        <form onSubmit={handleSubmit} method="POST">
          <div style={{ marginBottom: '15px' }}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '14px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                outline: 'none',
                fontSize: '16px',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '14px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                outline: 'none',
                fontSize: '16px',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '14px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                minHeight: '140px',
                resize: 'vertical',
                outline: 'none',
                fontSize: '16px',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              width: '100%',
              backgroundColor: '#7B0323',
              color: '#fff',
              padding: '14px',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '18px',
              fontWeight: '600',
              transition: '0.3s',
            }}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#5d0018')
            }
            onMouseOut={e =>
              (e.currentTarget.style.backgroundColor = '#7B0323')
            }
          >
            Submit
          </button>
        </form>

        {statusMessage && (
          <p
            style={{
              textAlign: 'center',
              color: '#7B0323',
              marginTop: '15px',
              fontWeight: '600',
            }}
          >
            {statusMessage}
          </p>
        )}
      </div>

      {/* Contact Cards */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '20px',
          padding: '20px',
        }}
      >
        {contacts.map((contact, index) => (
          <div
            key={index}
            style={{
              backgroundColor: '#fff',
              boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              borderRadius: '15px',
              padding: '20px',
              width: '100%',
              maxWidth: '450px',
              transition: '0.3s',
              boxSizing: 'border-box',
            }}
            onMouseEnter={e =>
              (e.currentTarget.style.transform = 'translateY(-5px)')
            }
            onMouseLeave={e =>
              (e.currentTarget.style.transform = 'translateY(0px)')
            }
          >
            <h2
              style={{
                color: '#7B0323',
                marginBottom: '15px',
                fontSize: '30px',
              }}
            >
              {contact.country}
            </h2>

            <div
              style={{
                color: '#555',
                fontSize: '17px',
                lineHeight: '28px',
              }}
            >
              {contact.country === 'ITALY' ? (
                <>
                  <p style={{ margin: '0 0 10px 0', fontWeight: '600' }}>
                    Mediterraneo Feed & Food Trading SRL
                  </p>
                  <p style={{ margin: '0 0 10px 0' }}>
                    In Collaboration With Edge Infinium
                  </p>
                  <p style={{ margin: '0' }}>
                    Via dei Tornabuoni 41 50123 Florence(FI) Tuscany, Italy
                  </p>
                </>
              ) : (
                <p>{contact.address}</p>
              )}
            </div>

            {/* Emails */}
            <div style={{ marginTop: '15px' }}>
              <strong style={{ color: '#7B0323' }}>Email:</strong>

              {contact.email.map((email, idx) => (
                <a
                  key={idx}
                  href={`mailto:${email}`}
                  style={{
                    display: 'block',
                    color: '#666',
                    marginTop: '8px',
                    textDecoration: 'none',
                    wordBreak: 'break-word',
                  }}
                >
                  {email}
                </a>
              ))}
            </div>

            {/* Phone */}
            {contact.phone && (
              <div style={{ marginTop: '15px' }}>
                <strong style={{ color: '#7B0323' }}>Phone:</strong>

                <a
                  href={`tel:${contact.phone}`}
                  style={{
                    display: 'block',
                    color: '#666',
                    marginTop: '8px',
                    textDecoration: 'none',
                  }}
                >
                  {contact.phone}
                </a>

                {contact.mobileNo && (
                  <a
                    href={`tel:${contact.mobileNo}`}
                    style={{
                      display: 'block',
                      color: '#666',
                      marginTop: '8px',
                      textDecoration: 'none',
                    }}
                  >
                    {contact.mobileNo}
                  </a>
                )}
              </div>
            )}

            {/* Website */}
            {contact.website && (
              <div style={{ marginTop: '15px' }}>
                <strong style={{ color: '#7B0323' }}>Website:</strong>

                <a
                  href={getWebsiteUrl(contact.website)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'block',
                    marginTop: '8px',
                    color: '#7B0323',
                    textDecoration: 'none',
                    wordBreak: 'break-word',
                  }}
                >
                  {contact.website}
                </a>
              </div>
            )}

            {/* Google Map */}
            {contact.mapSrc && (
              <div style={{ marginTop: '20px' }}>
                <iframe
                  title={`Map-${index}`}
                  width="100%"
                  height="250"
                  frameBorder="0"
                  style={{
                    border: 0,
                    borderRadius: '10px',
                  }}
                  src={contact.mapSrc}
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;
